import TampilanControls from '@components/settings/TampilanControls';
import { useLanguage } from '@contexts/LanguageContext';
import { ONBOARDING_MODAL_Z_INDEX } from '../constants';
import { resolveFirstLoginCopy } from '../i18n';
import StepHeading from '../StepHeading';

/** Step 0: theme, language, text size. Applies immediately; nothing to save on Next. */
export default function StepTampilan() {
  const { language } = useLanguage();
  const t = (key: string) => resolveFirstLoginCopy(language, key);

  return (
    <div className="flex flex-col gap-4">
      <StepHeading heading={t('tampilan.heading')} lead={t('tampilan.lead')} />
      {/* The language dropdown portals into the wizard's Mantine layer host; the z-index only
          orders it inside the wizard. */}
      <TampilanControls stacked dropdownZIndex={ONBOARDING_MODAL_Z_INDEX + 1} />
    </div>
  );
}
